import { render, staticRenderFns } from "./ServidorShow.vue?vue&type=template&id=35d08eb5&scoped=true&"
import script from "./ServidorShow.vue?vue&type=script&lang=js&"
export * from "./ServidorShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d08eb5",
  null
  
)

export default component.exports